import React from 'react';


const RoleStatus = props => {

    return (
        <div className="flex flex-40-60">
            <div className="container">
                    <span className={`role_dot ${props.name !== 'N/A' ? 'dot__filled': ''}`}/>
                <span>{props.alias}</span>
            </div>
            <div className="container">
                <span> - </span>
                <span>{props.name}</span>
            </div>
        </div>
    )
};

export default RoleStatus
